import React, { useState } from "react";
import axios from "axios";
import { RootState } from "store";
import { useSelector } from "react-redux";
import { RefreshIcon } from "@heroicons/react/solid";
import { RentripsURL } from "utils/request";

interface IOnUpload {
	path: string;
	order: number;
}

interface UploadProps {
	className?: string;
	img?: string;
	order?: number;
	onUpload?: ({ order, path }: IOnUpload) => void;
	onUpdate?: ({ order, path }: IOnUpload) => void;
	onDelete?: (id: number) => void;
	onUploadError: (error: string) => void;
}

const UploadProduct: React.FC<UploadProps> = ({
	className = "",
	order: id = 0,
	img,
	onUpload = () => {},
	onUpdate = () => {},
	onDelete = () => {},
	onUploadError = () => {},
}) => {
	const [uploading, setUploading] = useState(false);
	const { userInfo } = useSelector((state: RootState) => state.userInfo);
	const uploadHandler = async (e: any) => {
		const file = e.target.files[0];
		e.target.value = "";
		setUploading(true);

		const formData = new FormData();
		formData.append("image", file);

		try {
			const config = {
				headers: {
					Authorization: userInfo.token,
					"Content-Type": "multipart/form-data",
				},
				withCredentials: true,
			};

			const { data } = await axios.post(
				RentripsURL + "/api/upload/upload",
				formData,
				config
			);

			if (typeof data === "object") {
				setUploading(false);
				switch (data.message) {
					case "Image Only":
						return onUploadError(
							"Format yang diperkenankan: .jpg, .png, .jpeg"
						);
					case "File too large":
						return onUploadError("Ukuran file terlalu besar");
					default:
						return onUploadError("Terjadi kesalahan saat upload");
				}
			}

			onUpload({ order: id, path: data });
			e.preventDefault();
		} catch (error) {
			console.error(error);
			console.error(error);
		}
	};

	// const handleUpdate = async (e: any) => {
	//   setUploading(true);
	//   const file = e.target.files[0];
	//   e.target.value = "";

	//   const formData = new FormData();
	//   formData.append("image", file);

	//   try {
	//     const config = {
	//       headers: {
	//         Authorization: userInfo.token,
	//         "Content-Type": "multipart/form-data",
	//       },
	//       withCredentials: true,
	//     };

	//     const { data } = await axios.post("/api/upload", formData, config);
	//     setUploading(false);
	//     onUpdate({ order: id, path: data });
	//     e.preventDefault();
	//   } catch (error) {
	//     console.error(error);
	//   }
	// };

	const handleDelete = () => {
		setUploading(false);
		onDelete(id);
	};

	return (
		<div
			className={`relative mt-1 flex justify-center border-2 border-neutral-300 dark:border-neutral-6000 border-dashed rounded-md ${className}`}
		>
			{img && (
				<div className="absolute text-center h-full z-10">
					<img
						src={img}
						alt={img}
						className="object-cover h-full w-full rounded-md"
					/>
					{/* <div className="flex text-sm text-neutral-6000 dark:text-neutral-300 justify-center">
            <label className="relative cursor-pointer mt-2 rounded-md font-medium text-primary-6000 hover:text-primary-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500">
              <span>Ubah</span>

              <input type="file" className="sr-only" onChange={handleUpdate} />
            </label>
          </div> */}
					<span className="text-sm mt-1 text-red-500" onClick={handleDelete}>
						Hapus
					</span>
				</div>
			)}

			{uploading ? (
				<div className="my-2">
					{" "}
					<RefreshIcon className="animate-spin h-6 w-6 mx-auto" />
					<span>Uploading...</span>
				</div>
			) : (
				<div className="space-y-1 text-center px-6 pt-5 pb-6">
					<svg
						className="mx-auto h-12 w-12 text-neutral-400"
						stroke="currentColor"
						fill="none"
						viewBox="0 0 48 48"
						aria-hidden="true"
					>
						<path
							d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						></path>
					</svg>
					<div className="flex text-sm text-neutral-6000 dark:text-neutral-300">
						<label className="relative cursor-pointer rounded-md font-medium text-primary-6000 hover:text-primary-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500">
							<span>Upload</span>
							{id === 0 ? <span className="text-red-500"> *</span> : ""}

							<input type="file" className="sr-only" onChange={uploadHandler} />
						</label>
					</div>
				</div>
			)}
		</div>
	);
};

export default UploadProduct;
